import PurchaseRequestHeaderFilter from './PurchaseRequestHeaderFilter';
import PurchaseRequestTable from './PurchaseRequestTable';
import { useAuthStore } from '../../../store';

const PurchaseRequestPage = () => {
  const api = '/pr/requests';
  const moduleName = 'Purchase Request';
  const moduleCode = 'PR';
  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );
  return (
    <>
      <div className={'page-wrapper'}>
        <PurchaseRequestHeaderFilter />
        <PurchaseRequestTable
          api={api}
          moduleName={moduleName}
          userModuleAccess={userModuleAccess}
          userRole={user?.role}
        />
      </div>
    </>
  );
};

export default PurchaseRequestPage;
